import { ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { from } from 'rxjs';

import { untilDestroyed, UrlParamsService } from '@app/core';
import { SlimOrganization, User } from '@app/models';
import { AppService, UserService, AuthenticationService, OrganizationService, WhitelabelService, IntercomService, EnterpriseService } from '@app/services';
import { AppDropdown } from '@app/shared/dropdown/dropdown';
import { LoaderService } from '@app/shared/loader/loader.service';
import { CreateOrganizationModalService } from '@app/shared/create-organization-modal/create-organization-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: User;
  organizations: SlimOrganization[] = [];
  @ViewChild(AppDropdown, { static: false }) dropdown: AppDropdown;

  constructor(
    public appService: AppService,
    public userService: UserService,
    public router: Router,
    public translateService: TranslateService,
    public whitelabelService: WhitelabelService,
    public urlParamsService: UrlParamsService,
    public enterpriseService: EnterpriseService,
    private loaderService: LoaderService,
    private authenticationService: AuthenticationService,
    private organizationService: OrganizationService,
    private createOrganizationModalService: CreateOrganizationModalService,
    private intercomService: IntercomService
  ) {}

  ngOnInit() {
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => {
          this.currentUser = user;
          this.whitelabelService.loadWhitelabelByDomain();
        }
      });

    this.organizationService
      .watchOrganizations()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: organizations => (this.organizations = organizations)
      });
  }

  ngOnDestroy() {}

  openCreateOrganizationModal() {
    this.createOrganizationModalService.open().subscribe({
      next: () => {
        from(this.router.navigate(['/'])).subscribe({
          next: () => {
            this.userService.getCurrentUser({ fetchPolicy: 'network-only' }).subscribe();
            this.organizationService.getOrganizations({ fetchPolicy: 'network-only' }).subscribe();
          }
        });
      }
    });
  }

  selectDefaultOrganization(id: number) {
    if (!this.currentUser.organization || id !== this.currentUser.organization.id) {
      this.loaderService.show();

      this.organizationService.selectDefault({ id }).subscribe({
        next: () => (window.location.href = '/'),
        error: () => this.loaderService.hide()
      });
    }
  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: () => this.router.navigate(['/entrar'], { replaceUrl: true })
    });
  }

  isSubscriptionPaid(organization: SlimOrganization) {
    return organization && !['empresarial', 'free', 'autentique plus'].includes((organization.subscription.name || '').toLowerCase()) && !this.hasSubscriptionEnded(organization);
  }

  openChat() {
    this.intercomService.startTracking();
    this.intercomService.show();
  }

  closeChat() {
    this.intercomService.hide();
  }

  private hasSubscriptionEnded(organization: SlimOrganization) {
    return organization && organization.subscription.expires_at && new Date(organization.subscription.expires_at) < new Date();
  }
}
